import React from 'react';
import { Accordion } from '../../../components';
import { formatControlValue } from '../../../helpers/Functions';

import { SnippetConfiguration, SnippetDataDictionary } from '../../../services/dataModels';
import { DataRow } from './DataRow';

interface TableSnippetProps {
  path: string;
  configuration: SnippetConfiguration;
  data: SnippetDataDictionary[];
  canEditAllFields?: boolean;
}

const TableSnippet = ({ path, configuration, data, canEditAllFields }: TableSnippetProps) => {
  const titleControlType = configuration.columns.find(
    (c) => c.name === configuration.rowTitleKey,
  )?.controlType;

  return (
    <>
      {data.map((r, i) => (
        <Accordion
          key={i}
          size={configuration.columns.length}
          title={formatControlValue(titleControlType, r[configuration.rowTitleKey] as string)}>
          <DataRow
            path={`${path}.rowData[${i}]`}
            configuration={configuration.columns.filter((c) => c.name !== 'Key')}
            data={r}
            disabled={
              !canEditAllFields &&
              Object.keys(r).filter((key) => {
                if (key === 'Comments') return r.Key === '';
                return true;
              })
            }
          />
        </Accordion>
      ))}
    </>
  );
};

export default TableSnippet;
